<template>
  <el-form
    :model="form"
    :disabled="!isAllowToComplete"
    ref="form">
    <div class="row">
      <!-- FORM SEARCH -->
      <div class="col-12" v-if="isAllowToComplete">
        <form-search
          :rfQ2ID="rfQ2ID"
          :rfQ3ID="rfQ3ID"
          :stockID="stockID"
          @on-change-search="(key, value, map) =>{$emit('on-change-search',key, value, map)}"
        ></form-search>
      </div>
    </div>
    <div class="row">
      <!-- QI INFO -->
      <div class="col-xl-8 col-12">
        <!-- title -->
        <div class="row">
          <div class="col-12">
            <h3>{{L10n('qa-info')}}</h3>
          </div>
        </div>
        <!-- content -->
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-6 col-12">
            <el-form-item
              :label="L10n('part-number')"
              prop="partID"
              class="material-style"
              :rules="getValidationRule('required')"
            >
              <select-part-number
                :model.sync="form.partID"
                @update:model="updateModelItem('partID', { required: true })"
                @on-data-value="onPartNumber"
              >
              </select-part-number>
            </el-form-item>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 col-12">
            <el-form-item
              :label="L10n('S/N')"
              prop="partSN"
              class="material-style"
              :rules="getValidationRule('required')"
            >
              <el-input
                v-model="form.partSN"
                @change="updateModelItem('partSN', { required: true })"
              />
            </el-form-item>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 col-12">
            <el-form-item
              :label="L10n('entryDate')"
              :rules="getValidationRule('required')"
              prop="entryDate"
              class="material-style">
              <date-picker
                v-model="form.entryDate"
                @change="updateModelItem('entryDate', { required: true })"
              />
            </el-form-item>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 col-12">
            <el-form-item
              :label="L10n('qty')"
              :rules="getValidationRule('required,numberInteger')"
              prop="qty"
              class="material-style">
              <el-input
                :value="form.qty"
                @input="form.qty = valueNumber($event)"
                @change="updateModelItem('qty', { required: true })"
              />
            </el-form-item>
          </div>
          <div class="col-xl-8 col-lg-4 col-md-6 col-12">
            <el-form-item
              :label="L10n('supplier')"
              :rules="getValidationRule('required')"
              prop="supplierCompanyID"
              class="material-style"
            >
              <select-company
                :model.sync="form.supplierCompanyID"
                @update:model="updateModelItem('supplierCompanyID', { required: true })"
                @on-data-value="handlerChangeSupplier"
              >
              </select-company>
            </el-form-item>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-12">
            <el-form-item
              :label="L10n('sel-condition')"
              :rules="getValidationRule('required')"
              prop="conditionID"
              class="material-style"
            >
              <select-response-auto-complete
                :model.sync="form.conditionID"
                @update:model="updateModelItem('conditionID', { required: true })"
                api="Conditions/GetAllDynamic"
              ></select-response-auto-complete>
            </el-form-item>
          </div>
          <div class="col-md-6 col-12">
            <el-form-item
              :label="L10n('release')"
              :rules="getValidationRule('required')"
              prop="releaseID"
              class="material-style"
            >
              <select-response
                :model.sync="form.releaseID"
                @update:model="updateModelItem('releaseID', { required: true })"
                :data="dataSourceRelease.records"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-md-6 col-12">
            <el-form-item
              :label="L10n('employee')"
              :rules="getValidationRule('required')"
              prop="employeeID"
              class="material-style"
            >
              <select-response
                :model.sync="form.employeeID"
                @update:model="updateModelItem('employeeID', { required: true })"
                :data="dataSourceEmployee.records"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-md-4 col-12">
            <el-form-item
              :label="L10n('tag-date')"
              prop="tagDate"
              class="material-style">
              <date-picker
                v-model="form.tagDate"
                @change="updateModelItem('tagDate', { required: false })"
              />
            </el-form-item>
          </div>
          <div class="col-md-4 col-12">
            <el-form-item
              :label="L10n('weight-dimensions')"
              prop="weightDimensions"
              class="material-style"
            >
              <el-input
                :value="form.weightDimensions"
                @input="form.weightDimensions = valueTrimLeft($event)"
                @change="updateModelItem('weightDimensions', { required: false })"
              />
            </el-form-item>
          </div>
          <div class="col-md-4 col-12">
            <el-form-item
              :label="L10n('mfg-date')"
              prop="mfgDate"
              class="material-style">
              <date-picker
                v-model="form.mfgDate"
                @change="updateModelItem('mfgDate', { required: false })"
              />
            </el-form-item>
          </div>
          <div class="col-12" :class="isAllowToComplete ? 'col-sm-8' : 'col-sm-6'">
            <el-form-item
              :label="L10n('tag-by')"
              prop="tagInfoCompanyID"
              class="material-style"
            >
              <select-company
                :model.sync="form.tagInfoCompanyID"
                @update:model="updateModelItem('tagInfoCompanyID', { required: false })"
                :placeholder="placeholderTagAndTrace"
              >
              </select-company>
            </el-form-item>
          </div>
          <div v-if="isAllowToComplete" class="col-sm-4 col-12">
            <button
              type="button"
              class="btn btn-white btn-size-m btn-supplier btn-mobile-full"
              :disabled="disabledTagBtn"
              @click="setLikeSupplier('tagInfoCompanyID')">
              {{L10n('tag-by-supplier')}}
            </button>
          </div>
          <div class="col-12" :class="isAllowToComplete ? 'col-sm-8' : 'col-sm-6'">
            <el-form-item
              :label="L10n('trace')"
              :rules="getValidationRule('required')"
              prop="tracebilityCompanyID"
              class="material-style"
            >
              <select-company
                :model.sync="form.tracebilityCompanyID"
                @update:model="updateModelItem('tracebilityCompanyID', { required: true })"
                :placeholder="placeholderTagAndTrace"
              >
              </select-company>
            </el-form-item>
          </div>
          <div v-if="isAllowToComplete" class="col-sm-4 col-12">
            <button
              type="button"
              class="btn btn-white btn-size-m btn-supplier btn-mobile-full"
              :disabled="disabledTraceBtn"
              @click="setLikeSupplier('tracebilityCompanyID')">
              {{L10n('trace-supplier')}}
            </button>
          </div>
          <div class="col-8">
            <el-form-item
              :label="L10n('stock')"
              prop="stockID"
              class="material-style"
            >
              <select-response-auto-complete
                :model.sync="form.stockID"
                :columns="[
                  {title: L10n('part-number'), value: 'partNumber'}, {title: L10n('part-sn'), value: 'partSN'},
                  {title: L10n('condition'), value: 'conditionTitle'}, {title: L10n('release'), value: 'releaseTitle'},
                  {title: L10n('supplier'), value: 'supplierName'}, {title: L10n('po'), value: 'baxpoNumber'},
                  ]"
                @update:model="updateModelItem('stockID', { required: false })"
                api="Panels/GetAllPanelStock"
                selected="stockID,partNumber,partSN,conditionTitle,releaseTitle,supplierName,baxpoNumber"
                :fields="{id: 'stockID', title: 'partNumber'}"
                :orderBy="{fields: 'stockID', order: 'desc'}"
              >
              </select-response-auto-complete>
            </el-form-item>
          </div>
          <div class="col-4">
            <el-form-item
              :label="L10n('awb-details')"
              prop="awbDetails"
              class="material-style"
            >
              <el-input
                :value="form.awbDetails"
                @input="form.awbDetails = valueTrimLeft($event)"
                @change="updateModelItem('awbDetails', { required: false })"
              />
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('remarks')"
              prop="conditionID"
              class="material-style"
            >
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.remark"
                @change="updateModelItem('remark', { required: false })"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <!-- QA CHECK -->
      <div
        class="col-xl-4 col-12 vb-xl"
      >
        <!-- title -->
        <div class="row">
          <div class="col-12">
            <h3>{{L10n('qa-check')}}</h3>
          </div>
        </div>
        <!-- content -->
        <div class="row">
          <div class="col-xl-6 col-sm-4 col-12">
            <el-checkbox
              v-model="form.packagingIn"
              @change="updateModelItem('packagingIn', { required: false })"
            >
              {{L10n('packaging-in')}}
            </el-checkbox>
          </div>
          <div class="col-xl-6 col-sm-4 col-12">
            <el-checkbox
              v-model="form.packagingOut"
              @change="updateModelItem('packagingOut', { required: false })"
              >
              {{L10n('packaging-out')}}
            </el-checkbox>
          </div>
          <div class="col-xl-6 col-sm-4 col-12">
            <el-checkbox
              v-model="form.nonIncident"
              @change="updateModelItem('nonIncident', { required: false })"
            >
              {{L10n('non-incident')}}
            </el-checkbox>
          </div>
          <div class="col-xl-6 col-sm-4 col-12">
            <el-checkbox
              v-model="form.technicalReport"
              @change="updateModelItem('technicalReport', { required: false })"
            >
              {{L10n('technical-report')}}
            </el-checkbox>
          </div>
          <div class="col-xl-6 col-sm-4 col-12">
            <el-checkbox
              v-model="form.partVisualCheck"
              @change="updateModelItem('partVisualCheck', { required: false })"
            >
              {{L10n('part-visual-check')}}
            </el-checkbox>
          </div>
          <div class="col-xl-6 col-sm-4 col-12">
            <el-checkbox
              v-model="form.releaseApproved"
              @change="updateModelItem('releaseApproved', { required: false })"
            >
              {{L10n('release-approved')}}
            </el-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <el-form-item
              :label="L10n('airworthy')"
              prop="awb"
              data-filed="true"
              class="material-style">
              <el-radio-group
                v-model="form.awb"
                @change="updateModelItem('awb', { required: false })"
              >
                <el-radio label="Yes">{{L10n('yes')}}</el-radio>
                <el-radio label="NO">{{L10n('no')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <div v-if="isAllowToComplete" class="row">
          <div class="col-xl-auto col-sm-4 col-12 py-3">
            <button
              type="button"
              class="btn btn-white btn-size-m btn-mobile-full"
              :disabled="typeof rfQ2ID !== 'number'"
              @click.prevent="$emit('on-update-po')"
            >
              {{L10n('update-po-date-rcvd/qty')}}
            </button>
          </div>
          <div class="col-xl-auto col-sm-4 col-12 py-3">
            <button
              type="button"
              class="btn btn-white btn-size-m btn-mobile-full"
              :disabled="typeof rfQ2ID !== 'number'"
              @click.prevent="$emit('on-update-customer')"
            >
              {{L10n('update-customer-f-u')}}
            </button>
          </div>
          <div class="col-xl-auto col-sm-4 col-12 py-3">
            <button
              type="button"
              class="btn btn-white btn-size-m btn-mobile-full"
              :disabled="typeof rfQ3ID !== 'number'"
              @click.prevent="$emit('on-add-core')"
            >
              {{L10n('add-core-line-to-rfq3')}}
            </button>
          </div>
          <div class="col-xl-auto col-sm-4 col-12 py-3">
            <button
              type="button"
              class="btn btn-white btn-size-m btn-mobile-full"
              :disabled="typeof rfQ3ID !== 'number'"
              @click.prevent="$emit('on-open-customer-followup')"
            >
              {{L10n('open-customer-followup')}}
            </button>
          </div>
          <div class="col-xl-auto col-sm-4 col-12 py-3">
            <button
              type="button"
              class="btn btn-white btn-size-m btn-mobile-full"
              :disabled="typeof rfQ3ID !== 'number'"
              @click.prevent="$emit('on-open-supplier-followup')"
            >
              {{L10n('open-supplier-followup')}}
            </button>
          </div>
          <div class="col-xl-auto col-sm-4 col-12 py-3">
            <button
              type="button"
              class="btn btn-white btn-size-m btn-mobile-full"
              :disabled="typeof stockID !== 'number'"
              @click.prevent="$emit('on-update-stock')"
            >
              {{L10n('update-stock')}}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12 py-3">
            <button
              v-if="isAllowToComplete"
              type="button"
              class="btn btn-size-m btn-mobile-full"
              @click="$emit('on-complete')"
            >
              {{L10n('complete-qi')}}
            </button>
            <button
              v-else-if="isAllowToEdit"
              type="button"
              class="btn btn-size-m btn-mobile-full"
              @click="$emit('on-edit')"
            >
              {{L10n('edit-qi')}}
            </button>
          </div>
        </div>
        <div v-if="Boolean(stockTechnicalRemark)">
          <h3>{{L10n('stock-tech-remark')}}</h3>
          {{stockTechnicalRemark}}
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
// mixins
import Form from '@/components/Form/Form'

export default {
  name: 'FormQI',
  mixins: [Form],
  components: {
    'form-search': () => import(/* webpackChunkName: 'QI' */ './FormSearch.vue'),
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  props: {
    stockTechnicalRemark: { required: false },
    rfQ2ID: { required: true },
    rfQ3ID: { required: true },
    stockID: { required: true },
    isAllowToComplete: { type: Boolean, required: true },
    isAllowToEdit: { type: Boolean, required: true }
  },
  data () {
    return {
      supplierName: ''
    }
  },
  computed: {
    placeholderTagAndTrace () {
      return this.form.supplierCompanyID && this.supplierName
        ? this.supplierName
        : this.L10n('select')
    },
    disabledTagBtn () {
      return !(this.form.supplierCompanyID)
    },
    disabledTraceBtn () {
      return !(this.form.supplierCompanyID)
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title')
    }
  },
  methods: {
    onPartNumber (data) {
      this.$emit('onPartNumber', data)
    },
    setLikeSupplier (fieldName) {
      if (this.form[fieldName] === this.form.supplierCompanyID) {
        return
      }
      this.form[fieldName] = this.form.supplierCompanyID
      this.updateModelItem(fieldName)
    },
    handlerChangeSupplier (supplierData) {
      this.supplierName = supplierData
        ? supplierData.name
        : null
    }
  }
}
</script>
